/**
 * Wrapper Input for the Zappos UI Input to pass Lumon style overrides
 */
import { forwardRef } from 'react';
import { Input as DesignLibraryInput, type InputProps } from '@mweb/zappos-ui/Input';

import { cn } from 'helpers/classnames';
import { useIsKeyboardNavigation } from 'hooks/useIsKeyboardNavigation';

// TODO(Rebrand): Drop the Kratos version here once implemented.
// There are too many child elements to style with Tailwind efficiently,
// and it makes sense to copy + paste the new one.
export const InputV2 = ({ inputClassName, ...forwardProps }: InputProps) => {
  const isKeyboardUser = useIsKeyboardNavigation();
  return (
    // `className` prop on this doesn’t target container element
    <div className="zappos:[&_*]:font-sans zappos:[&_.rounded-lg]:rounded-sm">
      <DesignLibraryInput inputClassName={cn(inputClassName, !isKeyboardUser && 'focus-hidden')} {...forwardProps} />
    </div>
  );
};

// Since replacing all inputs with the design library input is not possible at the moment
// this simple input helps organize functionality without the need to refactor the whole app
export const Input = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(({ className, ...props }, ref) => {
  const isKeyboardUser = useIsKeyboardNavigation();
  return <input ref={ref} className={cn(className, !isKeyboardUser && 'focus-hidden')} {...props} />;
});
